import { __DEV__ } from '@mote/helpers/constants'
import { mergeClassnames } from '@mote/helpers/dom'
import { x } from '@xstyled/styled-components'
import type { HTMLXStyledProps } from '../../system'
import { forwardRef } from '../../system'

export interface DialogFooterProps extends HTMLXStyledProps<'footer'> {}

export const DialogFooter = forwardRef<DialogFooterProps, 'footer'>(
  (props, ref) => {
    const { className, flexDirection = 'row', ...rest } = props
    const _className = mergeClassnames('mote-dialog__footer', className)

    return (
      <x.footer
        display='flex'
        flexDirection={flexDirection}
        alignItems='center'
        justifyContent='flex-end'
        gap={3}
        pt={4}
        pb={6}
        px={6}
        {...rest}
        ref={ref}
        className={_className}
      />
    )
  }
)

if (__DEV__) {
  DialogFooter.displayName = 'DialogFooter'
}
